
import { Component, Vue, Prop, Watch, Emit, Ref, Mixins } from 'vue-property-decorator'
import NewSwiper from '@xt/www/components/newSwiper/index.vue'
import SeriesTabs from './tabs/seriesTabs.vue'
import SingleContent from './content/singleContent.vue'
import MultiContent from './content/multiContent.vue'
import { SingleCourseConent } from '@xt/client/types/home'
import { Observer } from 'mobx-vue'
import { MixinsHomeClick } from '@xt/client/mixins/home'

@Observer
@Component({
  components: {
    NewSwiper,
    SeriesTabs,
    SingleContent,
    MultiContent
  }
})
export default class ChinaPaintSeries extends Mixins(MixinsHomeClick) {
  activeIndex = 0

  get Content() {
    return this.dataSource?.tabs[this.activeIndex].content
  }

  get dataSource() {
    return this.$store.$homeV2.dataSource?.chinesePaintingCourse
  }

  get CurrentComponent() {
    return this.isSingleContent(this.dataSource?.tabs[this.activeIndex].content) ? 'SingleContent' : 'MultiContent'
  }

  handleClickMore() {
    if (this.dataSource?.more) {
      this.onClickEvent(this.dataSource.more)
      return
    }

    window.open('/product/list?typeCurrent=1&directionCurrent=2')
  }

  isSingleContent(item: any): item is SingleCourseConent {
    return item.background ? true : false
  }

  changeTabs(index) {
    this.activeIndex = index
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
